import { render, staticRenderFns } from "./YearField.vue?vue&type=template&id=04495444&"
import script from "./YearField.vue?vue&type=script&lang=js&"
export * from "./YearField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports